// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oiIQ0","content":"styles_content__qtO-3","tableWrap":"styles_tableWrap__12F0j"};